import * as React from 'react'
import { IControlProps } from './types'
import { formatDate } from '../../utils/dates'
import { GRID_CELLPADDING, GRID_CELLFONTSIZE } from './grids/consts'
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { parseISO, isValid } from 'date-fns'
import { CONFIG } from '../../config'
import InputAdornment from '@material-ui/core/InputAdornment'
import EventIcon from '@material-ui/icons/Event'
import DateFnsUtils from '@date-io/date-fns'
export interface IDateTimeControlState {
  value: any
}

export default class DateTimeControl extends React.Component<
  IControlProps,
  IDateTimeControlState
> {
  dateTimeFormat: string
  includeOffset: boolean
  constructor(props: any) {
    super(props)
    if (props.dateTimeIncludeOffset) {
      this.includeOffset = true
    } else {
      this.includeOffset = false
    }
    this.handleChange = this.handleChange.bind(this)
    if (props.dateTimeFormat) {
      // eslint-disable-next-line no-useless-escape
      this.dateTimeFormat = props.dateTimeFormat.replace(/\'/gi, '')
    } else {
      this.dateTimeFormat = CONFIG.displayDateTimeFormat
    }
    const initialValue = this.fromStoredValue(this.props.field.value || '')
    if (initialValue == '') {
      this.state = {
        value: null
      }
    } else {
      this.state = {
        value: initialValue
      }
    }
  }

  fromStoredValue(value: string) {
    return value ? parseISO(value) : ''
  }

  toStoredValue(value: string | null) {
    // Append seconds and current timezone to value
    if (this.includeOffset) return value ? formatDate('utc', value) : ''
    else return value ? formatDate('iso', value) : ''
  }

  handleChange(date: any) {
    if (date == null || isValid(date)) {
      this.props.form.setFieldValue(
        this.props.field.name,
        this.toStoredValue(date)
      )
    } else {
      this.props.form.setFieldValue(
        this.props.field.name,
        this.toStoredValue(null)
      )
    }
    this.setState({ value: date })
  }

  render() {
    if (this.props.gridCell) {
      const value = this.fromStoredValue(this.props.field.value || '')
      const displayValue = value
        ? formatDate('display_datetime', value, this.dateTimeFormat)
        : ''
      return (
        <div
          id={this.props.id}
          style={{ padding: GRID_CELLPADDING, fontSize: GRID_CELLFONTSIZE }}
        >
          {displayValue}
        </div>
      )
    } else {
      return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DateTimePicker
            views={['date', 'hours', 'minutes', 'seconds'] as any}
            disabled={this.props.disabled}
            clearable
            value={this.state.value}
            onChange={(date) => this.handleChange(date)}
            format={this.dateTimeFormat}
            id={this.props.id}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <EventIcon />
                </InputAdornment>
              )
            }}
          />
        </MuiPickersUtilsProvider>
      )
    }
  }
}
